import { searchAssociatedEmployersByTitle, getEmployerOrgInfo, getSubOrganizationsByParent } from '../api'

export const searchAssociatedEmployers = ({ state, commit }, {page, count, title}) => {
  return searchAssociatedEmployersByTitle(page, count, title)
}

export const loadEmployerOrgInfo = ({ state, commit }, employerId) => {
  return getEmployerOrgInfo(employerId)
}

export const loadSubOrganizationsByParent = ({ state, commit }, parentId) => {
  return getSubOrganizationsByParent(parentId)
}



// WEBPACK FOOTER //
// ./src/app/employer/vuex/actions.js